import {
  FulfillmentTypeId,
  FulfillmentTypeKey,
  FulfillmentIdMap
} from '@carvana/merch-contracts/FulfillmentType';
import { axios } from '~/clients';
import { GET_DELIVERY_PICKUP } from '~/constants/endpoints';
import { DeliveryPickupResponse } from '~/services/common/contracts';
import { BrowserCookies } from '~/utilities';

type Vehicle = {
  fulfillmentType: FulfillmentTypeId;
  isPurchasePending: boolean;
  locationId: number;
  vehicleId: number;
};

type VehicleForRequest = {
  vehicleId: number;
  vehicleInventoryType: FulfillmentTypeKey;
  vehicleLocationId: number;
  vehicleSaleStatus: string;
};

export function formatVehicleForRequest({
  fulfillmentType,
  isPurchasePending,
  locationId,
  vehicleId
}: Vehicle): VehicleForRequest {
  const vehicleSaleStatus = isPurchasePending ? '' : 'Available';

  return {
    vehicleId,
    vehicleInventoryType: FulfillmentIdMap[fulfillmentType],
    vehicleLocationId: locationId,
    vehicleSaleStatus
  };
}

type OwnArgs = {
  clientId: string;
  correlationId: string;
  userId: string;
  vehicles: VehicleForRequest[];
  zip: string;
};

export default function fetchVehiclesDeliveryPickup(
  { clientId, correlationId, userId, vehicles, zip }: OwnArgs,
  controller: AbortController
) {
  return axios.post<DeliveryPickupResponse>(
    GET_DELIVERY_PICKUP,
    {
      userId,
      vehicles,
      zipCode: zip
    },
    {
      headers: {
        browsercookieid: BrowserCookies.get('BrowserCookieId') ?? '',
        clientId,
        correlationId
      },
      signal: controller.signal
    }
  );
}
